var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Link",
    transform: "translate(-900.375 -435.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_68"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M911.6,453.6c-0.4,0-0.8-0.2-1.1-0.5c-2.4-2.7-2.2-7,0.5-9.5l6.1-6.2c2.4-2.7,6.7-2.9,9.4-0.4 c2.6,2.9,2.3,7.1-0.4,9.6l-3,3.1c-0.6,0.6-1.5,0.6-2.1,0c-0.6-0.6-0.6-1.5,0-2.1l3.1-3.1c1.6-1.4,1.7-3.8,0.3-5.3 c-1.4-1.2-3.8-1.1-5.1,0.4l-6.2,6.3c-1.6,1.4-1.7,3.8-0.3,5.3c0.5,0.6,0.5,1.6-0.1,2.1C912.3,453.4,912,453.6,911.6,453.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M906.7,463.3c-1.6,0-3.2-0.6-4.5-1.7c-2.6-2.9-2.3-7.1,0.4-9.6l3-3.1c0.6-0.6,1.5-0.6,2.1,0 c0.6,0.6,0.6,1.5,0,2.1l-3.1,3.1c-1.6,1.4-1.7,3.8-0.3,5.3c1.4,1.3,3.8,1.1,5.1-0.4l6.2-6.3c1.6-1.4,1.7-3.8,0.3-5.3 c-0.5-0.6-0.5-1.6,0.1-2.1c0.6-0.5,1.6-0.5,2.1,0.1c2.4,2.7,2.2,7-0.5,9.5l-6.1,6.2C910.3,462.6,908.5,463.3,906.7,463.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.e5180b99d76ee7333d4c40200b5517a7.svg";
export { ForwardRef as ReactComponent };